/**
 * data structure for a version of "terms of service"
 */

export interface ITos {
    content: string;
    version: number;
    publishDate: Date;
}

export class Tos implements ITos {
    content: string;
    version: number;
    publishDate: Date;

    constructor(content: string, version: number | string, publishDate: Date | string) {
        this.content = content;
        this.version = Number(version);
        this.publishDate = publishDate instanceof Date ? publishDate : new Date(publishDate);
    }

    toJSON(): ITos {
        return {
            content: this.content,
            version: this.version,
            publishDate: this.publishDate
        };
    }
}

export interface ITosAcceptance {
    username: string;
    acceptanceDate: Date;
}

interface ITosAcceptanceFirebaseDoc extends ITosAcceptance {
    version: number;
}

export class TosAcceptance implements ITosAcceptanceFirebaseDoc {
    username: string;
    version: number;
    acceptanceDate: Date;

    // TODO add type 'Timestamp' for acceptanceDate
    constructor(username: string, version: number | string, acceptanceDate: Date | string) {
        this.username = username;
        this.version = Number(version);
        this.acceptanceDate =
            acceptanceDate instanceof Date ? acceptanceDate : new Date(acceptanceDate);
    }

    toJSON(): ITosAcceptanceFirebaseDoc {
        return {
            username: this.username,
            version: this.version,
            acceptanceDate: this.acceptanceDate
        };
    }
}
